import apiClient from '../client';
import { Employee, EmployeeInput } from '@shared/types';

export const employeeService = {
  /**
   * Get employees by type (1 = Sewer, 2 = Trimmer)
   */
  getEmployeesByType: async (employeeType: number): Promise<Employee[]> => {
    const response: any = await apiClient.get(`/employees/${employeeType}`);
    return response.data;
  },

  /**
   * Get employee by ID
   */
  getEmployeeById: async (id: number): Promise<Employee> => {
    const response: any = await apiClient.get(`/employees/detail/${id}`);
    return response.data;
  },

  /**
   * Create a new employee
   */
  createEmployee: async (employee: EmployeeInput): Promise<{ id: number }> => {
    const response: any = await apiClient.post('/employees', employee);
    return response.data;
  },

  /**
   * Update an employee
   */
  updateEmployee: async (id: number, employee: EmployeeInput): Promise<void> => {
    await apiClient.put(`/employees/${id}`, employee);
  },

  /**
   * Delete an employee
   */
  deleteEmployee: async (id: number): Promise<void> => {
    await apiClient.delete(`/employees/${id}`);
  },
};
